<template>
  <div class="page_six">
    <div class="container">
      <div class="partners">
        <h2>PARTNERS</h2>
        <div class="lvtiao"><img src="@/assets/img/lvtiao.png" alt="" /></div>
        <div class="partners_item">
          <!-- <img src="@/assets/img/footer/1.png" alt="" /> -->
          <img src="@/assets/img/footer/icon_IGDA.png" alt="" />
      
          <!-- <img src="@/assets/img/footer/ICON_capcom.png" alt="" /> -->
          <!-- <img src="@/assets/img/footer/ICON_weta.png" alt="" />
          <img src="@/assets/img/footer/ICON_epic.png" alt="" /> -->
        </div>
      </div>
      <div class="footer">
        <div class="icon_top">
          <img src="@/assets/img/footer/5logo1.png" alt="" />
        </div>

        <div class="icon_bottom">
          <img
            src="@/assets/img/footer/5icon2.png"
            alt=""
            @click="to('twitter')"
          />
          <img
            src="@/assets/img/footer/5icon7.png"
            alt=""
            @click="to('medium')"
          />
          <img
            src="@/assets/img/footer/5icon3.png"
            alt=""
            @click="to('discord')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  methods: {
    to(id) {
      if (id == "twitter") {
        window.open("https://twitter.com/0xMiracleGame", "_blank");
      } else if (id == "medium") {
        window.open("https://miraclegames.medium.com/", "_blank");
      } else if (id == "discord") {
        window.open("https://discord.gg/EnsvSAVZCv", "_blank");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page_six {
  width: 100%;
  height: 1280px;
  position: relative;
  .container {
    position: absolute;
    // top: 313px;
    top: 0px;
    left: 5rem;
    transform: translateX(-50%);
    width: 805px;
    height: 767px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .partners {
      width: 100%;
      height: 466px;
      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        width: 100%;
        height: 43px;
        font-size: 60px;
        font-family: icomoon;
        color: #fff;
        font-weight: 700;
        text-align: center;
      }
      .lvtiao {
        margin-top: 51px;
        width: 101px;
        height: 3px;
      }
      .partners_item {
        margin-top: 53px;
        width: 100%;
        height: 340px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-right: 42px;
          margin-bottom: 44px;
        }
      }
    }
    .footer {
      // margin-top: 416px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon_bottom {
        margin-top: 29px;
        width: 203px;
        height: 56px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        img {
          cursor: pointer;
        }
      }
    }
  }
}

@media (max-width: 1199px) {
  .page_six {
    width: 100vw;
    height: 14.4rem;
    position: relative;
    .container {
      width: 10rem;
      height: 10.346667rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .partners {
        // border: 1px solid #fff;
        width: 100%;
        height: 9.48rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        h2 {
          width: 100%;
          height: 0.586667rem;
          font-size: 0.8rem;
          font-family: icomoon;
          color: #fff;
          font-weight: 700;
          text-align: center;
        }
        .lvtiao {
          margin-top: 0.266667rem;
          width: 1.333333rem;
          height: 2px;
          img {
            width: 1.333333rem;
            height: 2px;
          }
        }
        .partners_item {
          // border: 1px solid red;
          margin-top: 1.12rem;
          width: 5rem;
          height: 6.533333rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            margin-bottom: 0.586667rem;
          }
          img:nth-child(1) {
            width: 4.64rem;
            height: 0.333333rem;
          }
          img:nth-child(2) {
            width: 1.44rem;
            height: 0.48rem;
          }
          img:nth-child(3) {
            width: 1.653333rem;
            height: 0.586666rem;
          }
          // img:nth-child(4) {
          //   width: 6.266666rem;
          //   height: 0.573333rem;
          // }
          // img:nth-child(5) {
          //   width: 2.32rem;
          //   height: 0.36rem;
          // }
          img:nth-child(4) {
            width: 1.72rem;
            height: 0.626666rem;
          }
          img:nth-child(5) {
            width: 1.026666rem;
            height: 1.186666rem;
          }
        }
      }
      .footer {
        // margin-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon_top {
          img {
            width: 5.226667rem;
            height: 0.933333rem;
          }
        }
        .icon_bottom {
          margin-top: 29px;
          width: 2.486667rem;
          height: 0.746667rem;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          img {
            cursor: pointer;
            height: 0.746667rem;
            width: 0.746667rem;
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .page_six {
    width: 100vw;
    height: 14.4rem;
    position: relative;
    .container {
      width: 10rem;
      height: 10.346667rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .partners {
        // border: 1px solid #fff;
        width: 100%;
        height: 9.88rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        h2 {
          width: 100%;
          height: 0.586667rem;
          font-size: 0.8rem;
          font-family: icomoon;
          color: #fff;
          font-weight: 700;
          text-align: center;
        }
        .lvtiao {
          margin-top: 0px;
          width: 1.333333rem;
          height: 2px;
          img {
            width: 1.333333rem;
            height: 2px;
          }
        }
        .partners_item {
          // border: 1px solid red;
          margin-top: 1.44rem;
          width: 5rem;
          height: 6.533333rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            margin-bottom: 0.586667rem;
          }
          img:nth-child(1) {
            width: 4.64rem;
            height: 0.333333rem;
          }
          img:nth-child(2) {
            width: 1.44rem;
            height: 0.48rem;
          }
          img:nth-child(3) {
            width: 1.653333rem;
            height: 0.586666rem;
          }
          // img:nth-child(4) {
          //   width: 6.266666rem;
          //   height: 0.573333rem;
          // }
          // img:nth-child(5) {
          //   width: 2.32rem;
          //   height: 0.36rem;
          // }
          img:nth-child(4) {
            width: 1.72rem;
            height: 0.626666rem;
          }
          img:nth-child(5) {
            width: 1.026666rem;
            height: 1.186666rem;
          }
        }
      }
      .footer {
        // margin-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon_top {
          img {
            width: 5.226667rem;
            height: 0.933333rem;
          }
        }
        .icon_bottom {
          margin-top: 29px;
          width: 2.486667rem;
          height: 0.746667rem;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          img {
            cursor: pointer;
            height: 0.746667rem;
            width: 0.746667rem;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page_six {
    width: 100vw;
    height: 14.4rem;
    position: relative;
    .container {
      width: 10rem;
      height: 10.346667rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .partners {
        // border: 1px solid red;
        width: 100%;
        height: 8.68rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        h2 {
          // border: 1px solid red;
          width: 100%;
          height: 0.28rem;
          font-size: 0.8rem;
          font-family: icomoon;
          color: #fff;
          font-weight: 700;
          text-align: center;
        }
        .lvtiao {
          margin-top: 0;
          width: 1.333333rem;
          height: 2px;
          img {
            width: 1.333333rem;
            height: 2px;
          }
        }
        .partners_item {
          // border: 1px solid red;
          // margin-top: 1.44rem;
          width: 6.266667rem;
          height: 6.133333rem;
          display: flex;
          flex-direction: column;
          // align-items: center;
          img {
            margin-bottom: 0.586667rem;
            margin: 0.266667rem auto;
          }
          img:nth-child(1) {
            width: 4.64rem;
            height: 0.333333rem;
          }
          img:nth-child(2) {
            width: 1.44rem;
            height: 0.48rem;
          }
          img:nth-child(3) {
            width: 1.653333rem;
            height: 0.586666rem;
          }
          // img:nth-child(4) {
          //   width: 6.266666rem;
          //   height: 0.573333rem;
          // }
          // img:nth-child(5) {
          //   width: 2.32rem;
          //   height: 0.36rem;
          // }
          img:nth-child(4) {
            width: 1.72rem;
            height: 0.626666rem;
          }
          img:nth-child(5) {
            width: 1.026666rem;
            height: 1.186666rem;
          }
        }
      }
      .footer {
        // margin-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon_top {
          img {
            width: 5.226667rem;
            height: 0.933333rem;
          }
        }
        .icon_bottom {
          margin-top: 0.373333rem;
          width: 2.486667rem;
          height: 0.746667rem;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          img {
            cursor: pointer;
            height: 0.746667rem;
            width: 0.746667rem;
          }
        }
      }
    }
  }
}
</style>
